<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
<!--              <el-form-item label="课程">-->
<!--                  <el-input  v-model="queryForm.courseId"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="章节名称">
                  <el-input style="width: 177px" v-model="queryForm.charpterName"></el-input>
              </el-form-item>
              <el-form-item label="父ID">
<!--                  <el-input  v-model="queryForm.parentId"></el-input>-->
                  <el-select
                      clearable
                      style="width: 177px"
                      v-model="queryForm.parentId"
                      placeholder="请选择"
                      size="small"
                  >
                      <el-option
                          label="顶级目录"
                          value="0"
                      > </el-option>
                      <el-tree
                          :data="eduCourseCharpterList"
                          :props="treeProps"
                          :render-after-expand="false"
                      >
                          <div
                              class="custom-tree-node flex items-center"
                              slot-scope="{ node, data }"
                          >
                              <el-option
                                  :label="node.label"
                                  :value="data.id"
                              > </el-option>
                          </div>
                      </el-tree>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduCourseCharpterList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addEduCourseCharpter"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editEduCourseCharpter(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduCourseCharpter(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
<!--        <span-->
<!--          title="搜索"-->
<!--          class="icon-box"-->
<!--          @click="search"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <Search />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportEduCourseCharpterList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshEduCourseCharpterList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduCourseCharpterList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="courseId"-->
<!--        label="课程"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        prop="charpterName"
        label="章节名称"
      > </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="videoId"
            label="视频"
            v-if="type == 1"
        >
            <template slot-scope="scope">
                <div style="display: flex;justify-content: center;align-items: center">
                    {{ scope.row.video && scope.row.video.video ? scope.row.video.video.videoName : '--' }}
                    <i v-if="scope.row.video && scope.row.video.video" class="el-icon-video-play" style="margin-left: 4px; font-size: 18px;cursor: pointer" @click="startVideo(scope.row.video.video.videoUrl)"></i>
                </div>
            </template>
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="streamId"
            label="房间"
            v-if="type == 2"
        >
            <template slot-scope="scope">
                <div style="display: flex;justify-content: center;align-items: center">
                    {{ scope.row.stream && scope.row.stream.stream ? scope.row.stream.stream.streamName : '--' }}
<!--                    <i v-if="scope.row.video" class="el-icon-video-play" style="margin-left: 4px; font-size: 18px;cursor: pointer" @click="startVideo(scope.row.video.video.videoUrl)"></i>-->
                </div>
            </template>
        </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="parentId"-->
<!--        label="父ID"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="createTime"-->
<!--        label="创建时间"-->
<!--      > </el-table-column>-->
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="531"
      >
        <template slot-scope="scop">
          <div class="operation">
              <div @click="addRoom(scop.row)" v-if="type == 2">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">选择房间</span>
              </div>
            <div @click="addChildern(scop.row)" v-if="type == 1">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">选择视频</span>
            </div>
              <div @click="addMerterial(scop.row.id)">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">管理资料</span>
              </div>
              <div @click="addTextPaper(scop.row.id)">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">课后练习</span>
              </div>
              <div @click="addRecord(scop.row.id)">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">测试记录</span>
              </div>
              <div @click="addFx(scop.row.id)">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">测试分析</span>
              </div>
            <div @click="editEduCourseCharpter(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteEduCourseCharpter(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduCourseCharpterStates[eduCourseCharpterState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="eduCourseCharpter"
          ref="eduCourseCharpterForm"
          :rules="rules"
          label-width="80px"
          :inline="true"
          size="small"
        >
<!--          <el-form-item-->
<!--            label="课程"-->
<!--            prop="courseId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseCharpter.courseId"-->
<!--              :disabled="eduCourseCharpterState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="章节名称"
            prop="charpterName"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="eduCourseCharpter.charpterName"
              :disabled="eduCourseCharpterState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="上级章节"
            prop="parentId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseCharpter.parentId"-->
<!--              :disabled="eduCourseCharpterState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  clearable
                  style="width: 177px"
                  v-model="eduCourseCharpter.parentId"
                  placeholder="请选择"
                  :disabled="eduCourseCharpterState == 'check'"
                  size="small"
              >
                  <el-option
                      label="顶级目录"
                      value="0"
                  > </el-option>
                  <el-tree
                      :data="eduCourseCharpterList"
                      :props="treeProps"
                      :render-after-expand="false"
                  >
                      <div
                          class="custom-tree-node flex items-center"
                          slot-scope="{ node, data }"
                      >
                          <el-option
                              :label="node.label"
                              :value="data.id"
                          > </el-option>
                      </div>
                  </el-tree>
              </el-select>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseCharpter.sort"-->
<!--              :disabled="eduCourseCharpterState == 'check'"-->
<!--            ></el-input>-->
              <el-input-number
                  style="width: 177px"
                  :disabled="eduCourseCharpterState == 'check'"
                  v-model="eduCourseCharpter.sort"
                  size="small"
                  label=""
                  :min="1"
                  :max="100000"
                  :step="1"
                  :controls="true"
                  controls-position="both"
              >
              </el-input-number>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduCourseCharpterState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>

<!--      资料-->
      <el-dialog
          title="章节资料"
          :visible.sync="showMerterialDialog"
          width="60%"
          @close="closeMerterialDialog"
          :append-to-body="true"
      >
          <EduCourseCharpterMerterial style="height: 500px" ref="merterial"></EduCourseCharpterMerterial>
          <div
              slot="footer"
              class="flex justify-end"
          >
              <el-button @click="checkEduCourseCharpter">关闭</el-button>
<!--              <el-button-->
<!--                  type="primary"-->
<!--                  @click="submitForm"-->
<!--                  v-if="eduCourseCharpterState != 'check'"-->
<!--              >确定</el-button>-->
          </div>
      </el-dialog>
      <!--     视频-->
<!--      <el-dialog-->
<!--          title="章节视频"-->
<!--          :visible.sync="showVideo"-->
<!--          width="60%"-->
<!--          @close="closeVideoDialog"-->
<!--          :append-to-body="true"-->
<!--      >-->
<!--          <EduCourseCharpterVideo ref="videos" style="height: 500px"></EduCourseCharpterVideo>-->
<!--          <div-->
<!--              slot="footer"-->
<!--              class="flex justify-end"-->
<!--          >-->
<!--              <el-button @click="closeVideoDialog">关闭</el-button>-->
<!--          </div>-->
<!--      </el-dialog>-->
      <el-dialog
          title="章节视频"
          :visible.sync="showVideo"
          width="60%"
          @close="closeVideoDialog"
          :append-to-body="true"
      >
          <div>
              <el-form
                  :model="eduCourseCharpterVideo"
                  ref="eduCourseCharpterVideoForm"
                  :rules="rulesvideo"
                  label-width="120px"
                  :inline="true"
                  size="small"
              >
                  <!--          <el-form-item-->
                  <!--            label="章节"-->
                  <!--            prop="charpterId"-->
                  <!--          >-->
                  <!--            <el-input-->
                  <!--              size="small"-->
                  <!--              v-model="eduCourseCharpterVideo.charpterId"-->
                  <!--              :disabled="eduCourseCharpterVideoState == 'check'"-->
                  <!--            ></el-input>-->
                  <!--          </el-form-item>-->
                  <el-form-item
                      label="视频"
                      prop="videoId"
                  >
                      <!--            <el-input-->
                      <!--              size="small"-->
                      <!--              v-model="eduCourseCharpterVideo.videoId"-->
                      <!--              :disabled="eduCourseCharpterVideoState == 'check'"-->
                      <!--            ></el-input>-->
                  </el-form-item>
              </el-form>
          </div>

          <div
              slot="footer"
              class="flex justify-end"
          >
              <el-button @click="closeVideoDialog">关闭</el-button>
              <el-button
                  type="primary"
                  @click="sumbitVideo"
              >确定</el-button>
          </div>
      </el-dialog>
      <GridSelectU style="width: 177px;" title="选择视频" labelName="videoName" ref="gridSelectUser" v-show="false"
                   labelValue="id" :value="eduCourseCharpterVideo.videoId" :limit='1' size='small' placeholder='请选择视频'
                   @getValue="getValueUser" :columns="EDUCLASSVIDEO_code" :searchs="EDUCLASSVIDEO_search" dataListUrl="/edu/coursevideo/findList" entityBeanName="eduCourseVideo" queryEntityUrl="/edu/coursevideo/get">
      </GridSelectU>
      <!--     练习-->
      <el-dialog
          title="章节练习"
          :visible.sync="showTextPaper"
          width="60%"
          @close="closeTextPaperDialog"
          :append-to-body="true"
      >
          <EduCourseCharpterTestpaper ref="textpaper" style="height: 500px"></EduCourseCharpterTestpaper>
          <div
              slot="footer"
              class="flex justify-end"
          >
              <el-button @click="closeTextPaperDialog">关闭</el-button>
              <!--              <el-button-->
              <!--                  type="primary"-->
              <!--                  @click="submitForm"-->
              <!--                  v-if="eduCourseCharpterState != 'check'"-->
              <!--              >确定</el-button>-->
          </div>
      </el-dialog>
<!--      直播间-->
      <el-dialog
          title="章节房间"
          :visible.sync="showRoom"
          width="60%"
          @close="closeRoomDialog"
          :append-to-body="true"
      >
          <div>
              <el-form
                  :model="eduCourseCharpterStream"
                  ref="eduCourseCharpterStreamForm"
                  :rules="rulesRoom"
                  label-width="120px"
                  :inline="true"
                  size="small"
              >
<!--                  <el-form-item-->
<!--                      label="章节"-->
<!--                      prop="charpterId"-->
<!--                  >-->
<!--                      <el-input-->
<!--                          size="small"-->
<!--                          v-model="eduCourseCharpterStream.charpterId"-->
<!--                          :disabled="eduCourseCharpterStreamState == 'check'"-->
<!--                      ></el-input>-->
<!--                  </el-form-item>-->
                  <el-form-item
                      label="直播"
                      prop="streamId"
                  >
<!--                      <el-input-->
<!--                          size="small"-->
<!--                          v-model="eduCourseCharpterStream.streamId"-->
<!--                      ></el-input>-->

                  </el-form-item>
              </el-form>
          </div>

          <div
              slot="footer"
              class="flex justify-end"
          >
              <el-button @click="closeRoomDialog">关闭</el-button>
              <el-button
                  type="primary"
                  @click="sumbitRoom"
              >确定</el-button>
          </div>
      </el-dialog>
      <GridSelectU style="width: 177px;" title="选择直播" labelName="streamName" ref="gridSelectStream" v-show="false"
                   labelValue="id" :value="eduCourseCharpterStream.streamId" :limit='1' size='small' placeholder='请选择直播'
                   @getValue="getRoomUser" :columns="EDUCLASSCOURSEROOM_code" :searchs="EDUCLASSCOURSEROOM_search" dataListUrl="/edu/coursestream/findList" entityBeanName="eduCourseStream" queryEntityUrl="/edu/coursestream/get">
      </GridSelectU>
  </div>
      <playVideo ref="videoDiolag"></playVideo>

      <!--      测试分析-->
      <el-dialog
          title="测试分析"
          :visible.sync="showAnalysisDialog"
          width="60%"
          @close="closeAnalysisDialog"
          :append-to-body="true"
      >
          <EduExerciseExamAnalysis style="height: 500px" ref="analysis"></EduExerciseExamAnalysis>
          <div
              slot="footer"
              class="flex justify-end"
          >
              <el-button @click="closeAnalysisDialog">关闭</el-button>
          </div>
      </el-dialog>

      <!--      测试记录-->
      <el-dialog
          title="测试记录"
          :visible.sync="showRecordDialog"
          width="60%"
          @close="closeRecordDialog"
          :append-to-body="true"
      >
          <EduExerciseExam style="height: 500px" ref="record"></EduExerciseExam>
          <div
              slot="footer"
              class="flex justify-end"
          >
              <el-button @click="closeRecordDialog">关闭</el-button>
          </div>
      </el-dialog>

  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import EduClassCourse from '@/components/edu/EduClassCourse.vue';
import EduCourseCharpterMerterial from '@/components/edu/EduCourseCharpterMerterial.vue';
import EduCourseCharpterTestpaper from '@/components/edu/EduCourseCharpterTestpaper.vue';
import GridSelectU from '@/components/gridselect/index.vue';
import { EDUCLASSCOURSEROOM, EDUCLASSCOURSEVIDEO, EDUCLASSCOURSEROOM_SEARCH , EDUCLASSCOURSEVIDEO_SEARCH } from '@/utils/constant';
import playVideo from '@/components/video/playVideo.vue';
import EduExerciseExamAnalysis from '@/components/edu/EduExerciseExamAnalysis.vue';
import EduExerciseExam from '@/components/edu/EduExerciseExam.vue';

export default {
    components: {
        EduExerciseExam,
        GridSelectU,
        playVideo,
        EduExerciseExamAnalysis,
        EduCourseCharpterTestpaper,
        EduCourseCharpterMerterial,
        EduClassCourse,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduCourseCharpterList();
                    this.getEduCourseCharpterList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduCourseCharpterList();
                    this.getEduCourseCharpterList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     courseId: '', //课程
                     charpterName: '', //章节名称
                     parentId: '', //父ID
                     sort: '', //排序
                },
                treeProps: {
                    children: 'children',
                    label: 'charpterName'
                },
                // 视频
                eduCourseCharpterVideo: {
                    id: '', //
                    charpterId: '', //章节
                    videoId: '', //视频
                },
                rulesvideo: {
                    charpterId: [{ required: true, message: '章节不能为空', trigger: 'blur' }],
                    videoId: [{ required: true, message: '视频不能为空', trigger: 'blur' }],
                },
                EDUCLASSVIDEO_code: EDUCLASSCOURSEVIDEO,
                EDUCLASSVIDEO_search: EDUCLASSCOURSEVIDEO_SEARCH,

                // 房间
                eduCourseCharpterStream: {
                    id: '', //
                    charpterId: '', //章节
                    streamId: '', //直播
                },
                showRoom: false,
                rulesRoom: {
                    charpterId: [{ required: true, message: '章节不能为空', trigger: 'blur' }],
                    streamId: [{ required: true, message: '直播不能为空', trigger: 'blur' }],
                },
                EDUCLASSCOURSEROOM_code: EDUCLASSCOURSEROOM,
                EDUCLASSCOURSEROOM_search: EDUCLASSCOURSEROOM_SEARCH,


                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                showTextPaper: false,
                eduCourseCharpterState: 'add',
                eduCourseCharpterStates: {
                    add: '新建章节管理',
                    check: '查看章节管理',
                    edit: '修改章节管理'
                },
                showVideo: false,
                multipleSelection: [],
                eduCourseCharpterList: [],
                eduCourseCharpter: {
                    id: '', //
                    courseId: '', //课程
                    charpterName: '', //章节名称
                    parentId: '', //父ID
                    sort: '', //排序
                },
                type: null,
                btnLoading: false,
                showMerterialDialog: false,
                rules: {
                    id: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    courseId: [{ required: true, message: '课程不能为空', trigger: 'blur' }],
                    charpterName: [{ required: true, message: '章节名称不能为空', trigger: 'blur' }],
                    // parentId: [{ required: true, message: '父ID不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                },
                showAnalysisDialog: false,
                showRecordDialog: false,
            };
        },
        created() {

        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            startVideo(url){
                console.log(url)
                this.$nextTick(()=>{
                    this.$refs.videoDiolag.dialogVisible = true
                    this.$refs.videoDiolag.videoSrc = url
                })
            },
            // 视频
            sumbitVideo(){
                if(this.eduCourseCharpterVideo.id){
                    post(`/edu/coursecharptervideo/edit`,{ ...this.eduCourseCharpterVideo }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.closeVideoDialog();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                }else{
                    post(`/edu/coursecharptervideo/add`,{ ...this.eduCourseCharpterVideo }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.closeVideoDialog();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                }
            },
            getValueUser(val){
                this.eduCourseCharpterVideo.videoId = val;
                console.log(this.eduCourseCharpterVideo)
                this.sumbitVideo();
            },

            // 房间
            addRoom(item){
                // this.showRoom = true;
                this.eduCourseCharpterStream.charpterId = item.id;
                this.eduCourseCharpterStream.id = item.stream ? item.stream.id : '';
                this.$refs.gridSelectStream.showSelectDialog();
            },
            closeRoomDialog(){
                this.showRoom = false;
                this.eduCourseCharpterStream = {
                    id: '', //
                    charpterId: '', //章节
                    streamId: '', //直播
                }
            },
            getRoomUser(val){
                this.eduCourseCharpterStream.streamId = val;
                this.sumbitRoom();
            },
            sumbitRoom(){
                // this.$refs.eduCourseCharpterStreamForm.validate((valid) => {
                //     if (valid) {
                //         console.log('submit');
                        if(this.eduCourseCharpterStream.id){
                            post(`/edu/coursecharpterstream/edit`,{ ...this.eduCourseCharpterStream }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.closeRoomDialog();
                                    this.refreshEduCourseCharpterList();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }else{
                            post(`/edu/coursecharpterstream/add`,{ ...this.eduCourseCharpterStream }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.closeRoomDialog();
                                    this.refreshEduCourseCharpterList();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                //     }
                // });
            },



            addMerterial(id){
                this.showMerterialDialog = true;
                this.$nextTick(()=>{
                    this.$refs.merterial.init(id);
                })
            },
            closeMerterialDialog(){
                this.showMerterialDialog = false;
            },
            addRecord(id){
                this.showRecordDialog = true;
                this.$nextTick(()=>{
                    this.$refs.record.init(id, 2);
                })
            },
            closeRecordDialog(){
                this.showRecordDialog = false;
            },
            addTextPaper(id){
                this.showTextPaper = true;
                this.$nextTick(()=>{
                    this.$refs.textpaper.init(id);
                })
            },
            closeTextPaperDialog(){
                this.showTextPaper = false;
            },
            addFx(id){
                this.showAnalysisDialog = true;
                this.$nextTick(()=>{
                    this.$refs.analysis.init(id, 2);
                })
            },
            closeAnalysisDialog(){
                this.showAnalysisDialog = false;
            },
            addChildern(item){
                // this.showVideo = true;
                this.$refs.gridSelectUser.showSelectDialog();
                this.eduCourseCharpterVideo.charpterId = item.id;
                this.eduCourseCharpterVideo.id = item.video ? item.video.id : '';
            },
            closeVideoDialog(){
                this.showVideo = false;
                this.eduCourseCharpterVideo = {
                    id: '', //
                    charpterId: '', //章节
                    videoId: '', //视频
                }
                this.refreshEduCourseCharpterList();
            },
            init(val,type){
                this.queryForm.courseId = val;
                this.eduCourseCharpter.courseId = val;
                this.type = type;
                this.getEduCourseCharpterList();
            },
            resetEduCourseCharpterList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduCourseCharpterList = [];
            },
            resetDialog() {
                this.eduCourseCharpterState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      courseId: this.queryForm.courseId, //课程
                      charpterName: '', //章节名称
                      parentId: '', //父ID
                      sort: '', //排序
                };
                this.getEduCourseCharpterList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduCourseCharpter = {
                      id: '', //
                      courseId: this.eduCourseCharpter.courseId, //课程
                      charpterName: '', //章节名称
                      parentId: '', //父ID
                      sort: '', //排序
                };
            },
            submitForm() {
                if (this.eduCourseCharpterState == 'add') {
                    this.$refs.eduCourseCharpterForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/coursecharpter/add`,{ ...this.eduCourseCharpter }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduCourseCharpterList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduCourseCharpterState == 'edit') {
                    this.$refs.eduCourseCharpterForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.eduCourseCharpter.children;
                            delete this.eduCourseCharpter.video;
                            delete this.eduCourseCharpter.stream;
                            delete this.eduCourseCharpter.studentrecord;
                            post(`/edu/coursecharpter/edit`,{ ...this.eduCourseCharpter }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduCourseCharpterList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduCourseCharpter() {
                this.showDialog = true;
                this.eduCourseCharpterState = 'add';
            },
            checkEduCourseCharpter(eduCourseCharpterId) {
                console.log(eduCourseCharpterId);
                this.currentEduCourseCharpterId = eduCourseCharpterId;

                this.getEduCourseCharpterById();
                this.showDialog = true;
                this.eduCourseCharpterState = 'check';
            },
            editEduCourseCharpter(eduCourseCharpterId) {
                console.log('eduCourseCharpter', eduCourseCharpterId);
                if (eduCourseCharpterId) {
                    this.currentEduCourseCharpterId = eduCourseCharpterId;
                    this.getEduCourseCharpterById();
                } else {
                    this.eduCourseCharpter = { ...this.eduCourseCharpter, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduCourseCharpterState = 'edit';
            },
            deleteEduCourseCharpter(eduCourseCharpterId) {
                let ids = '';
                if (eduCourseCharpterId) {
                    ids = eduCourseCharpterId;
                } else {
                    ids = this.multipleSelection.map((eduCourseCharpter) => eduCourseCharpter.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/coursecharpter/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduCourseCharpterList();
                                this.getEduCourseCharpterList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduCourseCharpterList() {
                this.resetEduCourseCharpterList();
                this.getEduCourseCharpterList();
            },
            getEduCourseCharpterList(query = {}) {
                this.loading = true;
                get(`/edu/coursecharpter/findAllAsTree`,{  courseId: this.queryForm.courseId }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduCourseCharpterList = res.treeData;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduCourseCharpterById() {
                get(`/edu/coursecharpter/get`,{ id: this.currentEduCourseCharpterId }).then((res) =>{
                    if(res.success){
                      this.eduCourseCharpter = { ...this.eduCourseCharpter, ...res.eduCourseCharpter };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduCourseCharpterList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/coursecharpter/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/coursecharpter/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/coursecharpter/importData`,formData);
              this.refreshEduCourseCharpterList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduCourseCharpterList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduCourseCharpterList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>